import { useQuery } from "@tanstack/react-query";
import { axiosInterceptor } from "..";
import { ModeUsageResponse } from "../interface";

const fetchModeBreakdown = async (
  orgId: string,
  subUserId: string
): Promise<ModeUsageResponse> => {
  const { data } = await axiosInterceptor.get(
    `progression-b2b/${orgId}/${subUserId}/mode-breakdown`
  );
  return data;
};

const useModeUsage = (orgId?: string, subUserId?: string) => {
  return useQuery({
    queryKey: ["modeBreakdown", orgId, subUserId],
    queryFn: () => {
      if (!orgId || !subUserId)
        return Promise.reject("Missing orgId or subUserId");
      return fetchModeBreakdown(orgId, subUserId);
    },
    enabled: !!orgId && !!subUserId,
  });
};

export default useModeUsage;
